import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output_c","exportFormat","exportButtonIcon"];
 
  connect() {
    console.log("Model exporter JS en cours ...");
    super.connect();
    this.updateIcon();
  }

  updateIcon() {
    const format = this.exportFormatTarget.value;
    const icon = this.exportButtonIconTarget;

    
    switch (format) {
      case "csv":
        icon.className = "fas fa-file-csv"; 
        break;
      case "xlsx":
        icon.className = "fas fa-file-excel";
        break;
      default:
        icon.className = "fas fa-file"; 
    }
  }

  get current_app() {
    return this.data.get("app");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}
